/* ============================================================
   SINGSPACE ADMIN - TITRE DE SECTION PARAMÈTRES (Pro Max)
   ============================================================ */

// import { SING_COLORS } from '../../constants/marketing-display.constants';

interface SectionTitleProps {
  label: string;
  description: string;
}

export function SectionTitle({ label, description }: SectionTitleProps) {
  return (
    <div className="mb-10 pb-6 border-b border-gray-100 relative">
      <div className="absolute bottom-0 left-0 w-12 h-1 bg-[#00758d] rounded-full" />
      <h2 className="text-2xl font-semibold text-slate-900 tracking-tight uppercase mb-2">{label}</h2>
      <p className="text-sm font-medium text-slate-500 max-w-2xl leading-relaxed">{description}</p>
    </div>
  );
}
